import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapMutations, mapState, mapActions } from 'vuex';
import categoryMixin from '@/views/creative/mixin/category.js';
import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js';
import ResourceUploader from './resource-uploader.vue';
import { groupMixin } from '../mixin/group';
import { fmtSize } from '@com/utils/data-format';
import { getFileExtension } from '@com/utils/file';
import useFileToExchangeResource from '@/views/creative/utils/use-file-to-exchange-resource';
import { getModelTexType } from '@/store/creative/template/model/util';
import { isCocosModelResource } from '@/views/creative/utils';

export default {
  components: {
    ResourceUploader: ResourceUploader
  },

  mixins: [categoryMixin, groupMixin],

  props: {
    category: {
      type: Object,
      required: true
    },

    buttonAttrs: {
      type: Object
    },

    origin: {
      type: String
    }
  },

  data: function data() {
    return {
      uploading: false
    };
  },


  computed: _extends({}, mapState({
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    }
  }), {
    resourceList: function resourceList() {
      if (this.templateConfig && this.category) {
        var list = useIdToFindResourceList({
          resource: this.templateConfig.resource,
          id: this.category.id
        });
        return list;
      }
      return [];
    },
    isCocosModel: function isCocosModel() {
      return this.isModel && this.resourceList && isCocosModelResource(this.resourceList[0]);
    },
    basicResource: function basicResource() {
      return this.resourceList.find(function (item) {
        return item.is_basic === 1;
      });
    },
    baseResourcePreviewUrls: function baseResourcePreviewUrls() {
      return _.get(this.basicResource, 'preview_urls_for_live_preview') || [];
    },
    basicResourcePreviewExtras: function basicResourcePreviewExtras() {
      return (_.get(this.basicResource, 'preview_extras') || []).map(function (item) {
        try {
          return JSON.parse(item);
        } catch (err) {
          console.log(err);
          return '';
        }
      }).filter(function (item) {
        return !_.isEmpty(item);
      });
    },
    fileMetaData: function fileMetaData() {
      if (this.isFrameSequence || this.isDragonBones) {
        return this.basicResourcePreviewExtras[0];
      }
      if (!this.basicResource || !this.basicResource.extra) return null;
      return this.basicResource.extra;
    },
    fileExt: function fileExt() {
      // 视频强制要求是 mp4，即便素材包本身的不是 mp4 格式
      if (this.category.file_type === 'video') {
        return 'MP4';
      }
      if (this.isModel) {
        // laya 模型包含lm文件判断含有fbx
        // cocos模型包含json、.bin文件判断含有fbx
        var hasFbx = function hasFbx(ext) {
          return ext === 'lm' || ext === 'json' || ext === 'bin';
        };
        return 'Zip (' + _.uniq(this.baseResourcePreviewUrls.map(function (a) {
          var ext = String(getFileExtension(a)).toLowerCase();
          return hasFbx(ext) ? 'fbx' : ext;
        })).join(' + ') + ')';
      }
      return this.category.file_ext || '';
    },


    // 模型图片格式
    modelTexType: function modelTexType() {
      return getModelTexType(this.baseResourcePreviewUrls);
    },
    fileSizeText: function fileSizeText() {
      var key = 'playTurbo.custom.resourceDialog';
      if (this.category.file_type === 'video') {
        return '' + this.$t(key + '.fileUpload.video');
      }
      if (this.isFrameSequence) {
        return '' + this.$t(key + '.fileUpload.frameSequence');
      }
      if (this.isDragonBones) {
        return '' + this.$t(key + '.fileUpload.dragonBones');
      }
      if (this.isModel) {
        return '' + this.$t(key + '.fileUpload.default');
      }
      return '' + this.$t(key + '.fileUpload.default');
    },
    fileSize: function fileSize() {
      if ((this.isFrameSequence || this.isDragonBones) && !_.isEmpty(this.basicResourcePreviewExtras)) {
        return fmtSize(this.basicResourcePreviewExtras.map(function (item) {
          return item.file_size;
        }).reduce(function (a, b) {
          return a + b;
        })) + '，';
      }
      return (_.get(this.fileMetaData, 'file_size') ? fmtSize(this.fileMetaData.file_size) : '') + '\uFF0C';
    }
  }),

  methods: _extends({}, mapMutations({
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    openCloudResourcesDialog: 'creative/template/openCloudResourcesDialog',
    openAddRepositoryResourceDialog: 'creative/template/openAddRepositoryResourceDialog',
    openAddLocalResourceDialog: 'creative/template/openAddLocalResourceDialog',
    updateAssetsDialog: 'creative/asset/updateAssetsDialog'
  }), mapActions({
    addResource: 'creative/template/addResource',
    dispatchConversionEvent: 'creative/template/model/dispatchConversionEvent'
  }), {
    open: function open() {
      var _this = this;

      this.updateCurrentCategory(this.category);
      if (this.isModel) {
        if (this.isCocosModel) {
          // cocos模型替换逻辑，使用add-local-resource-dialog上传zip文件
          this.openAddLocalResourceDialog({ action: 'add' });
        } else {
          // laya模型替换逻辑
          this.dispatchConversionEvent({
            texType: this.modelTexType,
            callback: function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                var newResource;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        newResource = useFileToExchangeResource({
                          file: file,
                          category: _this.category,
                          isZip: _this.isZip,
                          isModel: _this.isModel
                        });

                        _this.addResource(_extends({}, newResource, {
                          is_default: 0
                        }));

                      case 2:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function callback(_x) {
                return _ref.apply(this, arguments);
              };
            }()
          });
        }
      } else if (this.category.isRepository) {
        this.openAddRepositoryResourceDialog({ action: 'add' });
      } else {
        this.openAddLocalResourceDialog({ action: 'add' });
      }
    },
    clipName: function clipName(array) {
      var temp = array.map(function (item) {
        var arr = item.split('/');
        return arr[arr.length - 1];
      });
      if (temp.length > 3) {
        return temp[0] + ',' + temp[1] + ',...,' + temp[temp.length - 1];
      }
      return temp.join(',');
    },
    handleUploadSuccess: function handleUploadSuccess(_ref2) {
      var _this2 = this;

      var file = _ref2.file,
          resource = _ref2.resource;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var newResource;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!resource) {
                  _context2.next = 8;
                  break;
                }

                newResource = _extends({}, resource, {
                  file_md5: file.md5,
                  action: 'create',
                  resource_origin: 'local',
                  category_id: _this2.category.id
                });

                if (!_this2.resourceList.filter(function (item) {
                  return item.action !== 'del';
                }).some(function (item) {
                  return item.file_md5 === newResource.file_md5;
                })) {
                  _context2.next = 6;
                  break;
                }

                _this2.$message({
                  message: _this2.$t('playTurbo.custom.resourceDialog.uploadWarning'),
                  type: 'error'
                });
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return _this2.addResource(newResource);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleBeforeUpload: function handleBeforeUpload() {
      this.updateCurrentCategory(this.category);
    }
  }),
  mounted: function mounted() {}
};